import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { useTableArtifactsOptional } from './useTableArtifacts';

interface TableArtifactPreviewProps {
  tableId: string;
}

export const TableArtifactPreview: React.FC<TableArtifactPreviewProps> = ({ tableId }) => {
  const tableArtifactContext = useTableArtifactsOptional();
  const isLoading = tableArtifactContext?.isLoading ?? false;

  const handleViewDetails = useCallback(() => {
    if (tableArtifactContext) {
      tableArtifactContext.openTablePanel(tableId);
    }
  }, [tableArtifactContext, tableId]);

  return (
    <Box
      sx={{
        border: `1px solid ${colors.grey[300]}`,
        borderRadius: '12px',
        padding: 2,
        backgroundColor: 'white',
        width: '100%',
        transition: 'all 0.2s ease-in-out',
        cursor: tableArtifactContext ? 'pointer' : 'default',
      }}
      onClick={handleViewDetails}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography variant="body">Table Data</Typography>

          <Box sx={{ mb: '12px' }}>
            <Typography variant="caption" color={colors.grey[700]}>
              Data table artifact
            </Typography>
          </Box>

          <Button
            endIconName="ChevronRight"
            onClick={handleViewDetails}
            variant="flat-blue"
            disabled={isLoading || !tableArtifactContext}
          >
            {isLoading ? 'Loading...' : 'View details'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
